
import { useStore } from '@/store'
import { computed, defineComponent, onMounted, ref } from 'vue'
import StageDeterminerService from '@/services/page/stage-determiner.service'
import settings from '@/settings/settings.json'
import Analytics from '@/singletons/analytics'
import ToastService from '@/services/page/toast.service'
import SentrySingleton from '@/singletons/sentry-singleton'
import NameConverterService from '@/services/form/name-converter.service'

export default defineComponent({
  name: 'CheckoutButton',
  components: {},
  setup() {
    const store = useStore()
    const isAllConfigSet = computed(() => store.getters.isAllConfigSet)
    const nameConverterServivce = new NameConverterService()
    let link = ref(settings.ecsystemLinkProd)
    let apiKeyId = ref(settings.ecParams.apiKey)
    let apiKey = ref(settings.ecsystemApiKeyProd)
    let stageDeterminer = new StageDeterminerService()
    let toastService = new ToastService()
    let formVisible = ref(false)
    let namechar = ref()
    let formRef = ref()
    const inputs = ref([
      { id: settings.ecParams.size, value: store.getters.configBagsizeId },
      { id: settings.ecParams.body, value: store.getters.configBodyId },
      { id: settings.ecParams.edge, value: store.getters.configEdgeId },
      { id: settings.ecParams.thread, value: store.getters.configThreadId },
      { id: settings.ecParams.inside, value: store.getters.configInsideId },
      { id: settings.ecParams.pocket, value: store.getters.configPocketId },
      { id: settings.ecParams.side, value: store.getters.configSideId },
      { id: settings.ecParams.front, value: store.getters.configFrontId },
      { id: settings.ecParams.back, value: store.getters.configBackId },
      { id: settings.ecParams.tack, value: store.getters.configTackId },
      { id: settings.ecParams.isName, value: store.getters.configNonameId },
      { id: settings.ecParams.nameThread, value: store.getters.configNamethreadId },
      { id: settings.ecParams.nameChar, value: namechar }
    ])

    onMounted(() => {
      if (stageDeterminer.isStage()) {
        link.value = settings.ecsystemLinkStage
        apiKey.value = settings.ecsystemApiKeyStage
      }
    })

    const onClick = () => {
      if (!isAllConfigSet.value) {
        toastService.showError('未選択の項目があります\nすべての項目を選んでください')
      } else if (isNotInSalesPeriod()) {
        toastService.showError('今シーズンの受付は終了いたしました')
      } else {
        orderNow()
      }
    }

    function isNotInSalesPeriod() {
      var from = new Date(settings.salesPeriodStartProd).getTime()
      var to = new Date(settings.salesPeriodEndProd).getTime()
      if (stageDeterminer.isStage()) {
        from = new Date(settings.salesPeriodStartStage).getTime()
        to = new Date(settings.salesPeriodEndStage).getTime()
      }
      const today = new Date().getTime()
      return !(today >= from && today <= to)
    }

    function orderNow() {
      if (formVisible.value) {
        return
      }
      Analytics.instance.sendConfirmCombinationEvent(JSON.stringify(store.getters.currentConfig))
      formVisible.value = true
      namechar.value = getNameChar()
      try {
        if (stageDeterminer.isStage()) {
          link.value = settings.ecsystemLinkStage
          apiKey.value = settings.ecsystemApiKeyStage
        }
        setTimeout(() => {
          orderFistAttempt()
        }, 200)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function orderFistAttempt() {
      console.log(JSON.stringify(store.getters.currentConfig))
      console.log('first try to get form reference...')
      setTimeout(() => {
        const foundRef = getFormRef()
        if (foundRef) {
          foundRef.submit()
        } else {
          orderSecondAttempt()
        }
      }, 300)
    }

    function orderSecondAttempt() {
      console.log('second try to get form reference...')
      setTimeout(() => {
        const foundRef = getFormRef()
        if (foundRef) {
          foundRef.submit()
        } else {
          orderThirdAttempt()
        }
      }, 500)
    }

    function orderThirdAttempt() {
      console.log('third try to get form reference...')
      setTimeout(() => {
        const foundRef = getFormRef()
        if (foundRef) {
          foundRef.submit()
        } else {
          orderFourthAttempt()
        }
      }, 800)
    }

    function orderFourthAttempt() {
      console.log('forth try to get form reference...')
      setTimeout(() => {
        const foundRef = getFormRef()
        if (foundRef) {
          foundRef.submit()
        } else {
          formVisible.value = false
          alert('エラーが表示されました。 ページをリロードしてください')
          SentrySingleton.instance.captureMessage('Cannot get form reference after four attempts')
        }
      }, 1000)
    }

    function getFormRef() {
      if (formRef && formRef.value && formRef.value.submit) {
        return formRef.value
      }
      return document.getElementById('ec-post-form') as HTMLFormElement
    }

    function getNameChar() {
      const val = store.getters.configNamechar
      if (val == undefined || val == null || val.length <= 0) {
        return val
      }
      return nameConverterServivce.convertTo2ByteCharacters(val).toUpperCase()
    }

    return {
      link,
      apiKeyId,
      apiKey,
      inputs,
      formVisible,
      formRef,
      isAllConfigSet,
      onClick
    }
  }
})
